import { render } from "./SpinnerIcon.vue?vue&type=template&id=984dc642&scoped=true"
const script = {}

import "./SpinnerIcon.vue?vue&type=style&index=0&id=984dc642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984dc642"]])

export default __exports__